import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiRoute } from "services";
import API from "services/lib/api";
import { dataQueryStatus } from "utils";
// import { getErrorMessage } from "utils/helper";
import EmptyInfo from "components/ui/Empty/EmptyInfo/EmptyInfo";
import { otherCategories } from "components/dashboard/AgentInbox/enum";
import ChatModule from "./ChatModule/ChatModule";
import CustomerTicketsContainer from "./CustomerTicketsContainer/CustomerTicketsContainer";
import TicketDetail from "./TicketDetails/TicketDetail";
import CloseTicket from "./ChatModule/CloseTicket/CloseTicket";
import { deleteIncomingTicket, pushIncomingTickets, setIncomingTickets } from "store/tickets/incomingTickets/actions";
import * as types from "store/ticketsFilters/types";

import { motion, AnimatePresence } from "framer-motion";
import TicketsFilterGroup from "../TicketsFilterGroup/TicketsFilterGroup";
// import { setActiveTicket } from "store/tickets/actions";
import "./ChatTickets.scss";
import { getErrorMessage, isRequestCanceled, sortTickets } from "utils/helper";
import { selectNextTicket } from "./CustomerTicketsContainer/CustomerTickets/util/helper";
import { setActiveTicket } from "store/tickets/actions";
import { useDoesTicketMatchFilters } from "hooks/useDoesTicketMatchFilters";

const { IDLE, DATAMODE, LOADING, ERROR } = dataQueryStatus;
const { EXTERNAL_EMAILS } = otherCategories;

const ChatTickets = ({
    reconnectUser,
    refreshData,
    setTicketData,
    handleRefreshData,
    showFilters,
    toggleFilters,
    handleToggleEmailPreview,
    selectedTicketHeader,
    setSelectedTicketHeader,
    refetchEmails,
    handleSuccess,
    selectedCannedEmail,
    showEmailPreview,
    emailAction,
    emailPreviewValue,
    toggleEmailPreview,
    ticketData,
    handleRemoveEmailPreview,
    selectAgentGuide,
}) => {
    const { ticketsfilterRequest } = useSelector((state) => state?.ticketsFilters);

    const { ticketInfoValue, messageTagId, agentId, lastModified, search, keywordSearch, dateFilterType, dateFrom, dateTo } = ticketsfilterRequest;
    const { incomingTickets } = useSelector((state) => state?.incomingTickets);
    const doesTicketMatchFilters = useDoesTicketMatchFilters();
    

    const { activeTicket: selectedTicket } = useSelector(
        (state) => state?.tickets
    );
    const { page } = ticketsfilterRequest;

    const [status, setStatus] = useState(IDLE);
    const [fetchMessagesStatus, setFetchMessageStatus] = useState(IDLE);

    const [errorMssg, setErrorMssg] = useState("");
    const [showTicketActionModal, toggleTicketActionModal] = useState(false);
    const [showClipboard, toggleEmailClipboard] = useState(false);

    const [recentCustomerMessage, setRecentCustomerMessage] = useState("");
    const [investigativeCustomerMessage, setInvestigativeCustomerMessage] = useState("");
    const [selectedCustomerMessage, selectCustomerMessage] = useState({});

    const [ticketToClose, setTicketToClose] = useState({});
    const [cannedMessage, setCannedMessage] = useState("");
    const [attachments, setAttachments] = useState({
        fileAttachments: [],
        ticketAttachment: {},
    });

    const dispatch = useDispatch();

    const abortControllerRef = useRef(null);

    const handleToggleTicketActionModal = (ticket) => {
        toggleTicketActionModal(true);
        setTicketToClose(ticket);
    };

    const handleToggleEmailAttachment = (attachmentType, attachmentData) => {
        // toggleEmailAttachment(true);

        setSelectedTicketHeader(EXTERNAL_EMAILS);
        toggleEmailPreview(true);

        setAttachments((prev) => ({
            ...prev,
            [attachmentType]: attachmentData,
        }));

    };

    const toggleClipboardAndAttachment = (attachmentType) => {
        setSelectedTicketHeader(EXTERNAL_EMAILS);
        toggleEmailClipboard(true)
    }

    const handleTicketSuccess = (shouldDelete = true, activeTicket) => {
        console.log("incomingTickets", incomingTickets)
        console.log("activeTicket", (activeTicket))
        const filteredTickets = incomingTickets?.filter(ticket => doesTicketMatchFilters(ticket));
        const visibleTickets = sortTickets(filteredTickets, lastModified);
    
        selectNextTicket(
            ticketToClose,
            visibleTickets,
            (nextTicket, ticketId) => {
                dispatch(setActiveTicket(nextTicket));
                if (shouldDelete) {
                    const deleteTicketId = activeTicket ? activeTicket : ticketId
                    dispatch(deleteIncomingTicket({ ticketId: deleteTicketId }));
                }
                toggleTicketActionModal(false);
                setTicketToClose({});
            }
        );
        handleRefreshData();
    };

    const fetchAllTickets = async (search) => {
        const requestController = new AbortController();

        try {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }

            abortControllerRef.current = requestController;

            if(page === 1){
                setStatus(LOADING);
                setErrorMssg(null);
            }else{
                dispatch({ type: types.SET_TICKETS_LOADING, payload: true });
            }
           
            const url = apiRoute?.getTicketsByPagination;
            
            if (!url) return;

            const { cursorUpdatedDate, cursorId, page: requestPage, ...filterParams } =
                ticketsfilterRequest;

            // Page 1 is always a fresh window; later pages use keyset cursors
            // so live queue changes do not skip tickets under OFFSET.
            const paginationParams =
                requestPage > 1 && cursorUpdatedDate && cursorId
                    ? { cursorUpdatedDate, cursorId }
                    : {};
            
            // Use existing paginated endpoint with keywordSearch parameter
            const res = await API.get(url, {
                params: {
                    ...filterParams,
                    page: requestPage,
                    ...paginationParams,
                },
                signal: requestController.signal
            });

            if (requestController.signal.aborted || abortControllerRef.current !== requestController) {
                return;
            }


            if (res.status === 200) {
                const { data: tickets, metaData } = res.data;
                console.log("metaData", metaData)

                const lastTicket =
                    Array.isArray(tickets) && tickets.length > 0
                        ? tickets[tickets.length - 1]
                        : null;

                const pageSize = Number(metaData?.pageSize || filterParams.pageSize);
                const totalRecords = Number(metaData?.totalRecords);
                const currentPage = Number(metaData?.page || requestPage || 1);
                const hasKnownTotal = Number.isFinite(totalRecords) && pageSize > 0;
                const hasMoreByTotal = hasKnownTotal
                    ? currentPage * pageSize < totalRecords
                    : Array.isArray(tickets) && tickets.length >= pageSize;

                // Stop if the server returns the same page/cursor again. This
                // protects the observer from repeatedly requesting pages when
                // the live queue changes while it is being paged.
                const cursorAdvanced =
                    requestPage === 1 ||
                    !lastTicket ||
                    lastTicket.id !== cursorId ||
                    lastTicket.updatedDate !== cursorUpdatedDate;
                const pageAlreadyLoaded =
                    requestPage > 1 &&
                    Array.isArray(tickets) &&
                    tickets.length > 0 &&
                    tickets.every((ticket) =>
                        incomingTickets?.some(
                            (existingTicket) =>
                                (existingTicket.id || existingTicket.ticketId) ===
                                (ticket.id || ticket.ticketId)
                        )
                    );
                const hasMore =
                    Array.isArray(tickets) &&
                    tickets.length > 0 &&
                    hasMoreByTotal &&
                    cursorAdvanced &&
                    !pageAlreadyLoaded;

                dispatch({ type: types.SET_TICKETS_LOADING, payload: false });
                dispatch({
                    type: types.SET_TICKETS_META,
                    payload: { totalRecords: metaData.totalRecords, hasMore}
                });
                dispatch({
                    type: types.SET_TICKETS_PAGINATION_CURSOR,
                    payload: lastTicket
                        ? {
                              cursorUpdatedDate: lastTicket.updatedDate,
                              cursorId: lastTicket.id,
                          }
                        : { cursorUpdatedDate: undefined, cursorId: undefined },
                });

                if (metaData.page === 1) {
                    dispatch(setIncomingTickets(tickets));
                } else {
                    console.log("tickets", tickets)
                    dispatch(pushIncomingTickets([...tickets]));
                    console.log("incoming tickets", incomingTickets)

                }

                handleRemoveEmailPreview();
                setStatus(DATAMODE);
            }
        } catch (err) {
            // Ignore errors from aborted requests (when switching tabs/filters)
            const isAborted = isRequestCanceled(err, requestController);
            
            if (isAborted) {
                // Request was intentionally cancelled, don't show error
                if (abortControllerRef.current === requestController) {
                    dispatch({ type: types.SET_TICKETS_LOADING, payload: false });
                }
                return;
            }

            // Only show error for actual failures, not cancelled requests
            if (abortControllerRef.current !== requestController) {
                return;
            }

            if(page === 1){
                setStatus(ERROR);
                setErrorMssg(getErrorMessage(err));
            }
            dispatch({ type: types.SET_TICKETS_LOADING, payload: false });
        }
    };

    const clearSelectedCustomerMessage = () => {
        selectCustomerMessage({});
    };

    useEffect(() => {
        fetchAllTickets();
        setCannedMessage("");

        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, ticketInfoValue, messageTagId, lastModified, refreshData, agentId, search, keywordSearch, dateFilterType, dateFrom, dateTo]);


    return (
        <div className='chat__ticket__container'>
            <div className='col-8 pe-0'>
                <TicketsFilterGroup
                    {...{
                        showFilters,
                        toggleFilters,
                        refreshData,
                        handleRefreshData,
                        selectedTicketHeader,
                    }}
                />
                <div className='chat__ticket--section'>
                    <div className='container-fluid h-100'>
                        <div className='row h-100'>
                            <div className='col-4 pe-0'>
                                <CustomerTicketsContainer
                                    status={status}
                                    errorMssg={errorMssg}
                                    handleRetry={fetchAllTickets}
                                    handleRemoveEmailPreview={
                                        handleRemoveEmailPreview
                                    }
                                    selectedTicketHeader={selectedTicketHeader}
                                    clearSelectedCustomerMessage={clearSelectedCustomerMessage}
                                />
                            </div>
                            <div className='col-8 px-0'>
                                <AnimatePresence exitBeforeEnter>
                                    <motion.div
                                        className={`chat__container`}
                                        key={
                                            selectedTicket !== null
                                                ? selectedTicket?.ticketId
                                                : "empty"
                                        }
                                        initial={{ x: 10, opacity: 0 }}
                                        animate={{ x: 0, opacity: 1 }}
                                        exit={{ x: -10, opacity: 0 }}
                                        transition={{ duration: 0.5 }}>
                                        {selectedTicket !== null &&
                                            selectedTicket !== undefined ? (
                                            <ChatModule
                                                ticket={selectedTicket}
                                                setRecentCustomerMessage={
                                                    setRecentCustomerMessage
                                                }
                                                toggleTicketActionModal={(
                                                    ticket
                                                ) =>
                                                    handleToggleTicketActionModal(
                                                        ticket
                                                    )
                                                }
                                                key={selectedTicket?.ticketId}
                                                setTicketData={setTicketData}
                                                reconnectUser={reconnectUser}
                                                handleSuccess={
                                                    handleRefreshData
                                                }
                                                cannedMessage={cannedMessage}
                                                setCannedMessage={
                                                    setCannedMessage
                                                }
                                                showFilters={showFilters}
                                                attachments={attachments}
                                                {...{
                                                    handleTicketSuccess,
                                                    showEmailPreview,
                                                    emailAction,
                                                    emailPreviewValue,
                                                    toggleEmailPreview,
                                                    ticketData,
                                                    setSelectedTicketHeader,
                                                    setInvestigativeCustomerMessage,
                                                    setFetchMessageStatus,
                                                    selectedCustomerMessage,
                                                    selectCustomerMessage,
                                                    toggleClipboardAndAttachment,
                                                    handleToggleEmailAttachment
                                                }}
                                            />
                                        ) : (
                                            <EmptyInfo
                                                otherClassNames={"with-margin"}
                                                message={`No conversation started yet,\n click on a tag above to begin`}
                                            />
                                        )}
                                    </motion.div>
                                </AnimatePresence>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-4 ps-0'>
                <TicketDetail
                    recentCustomerMessage={recentCustomerMessage}
                    fetchAllTickets={fetchAllTickets}
                    setCannedMessage={setCannedMessage}
                    handleToggleEmailPreview={handleToggleEmailPreview}
                    handleToggleEmailAttachment={handleToggleEmailAttachment}
                    selectedTicketHeader={selectedTicketHeader}
                    setSelectedTicketHeader={setSelectedTicketHeader}
                    refetchEmails={refetchEmails}
                    selectedCannedEmail={selectedCannedEmail}
                    selectedEmailData={emailPreviewValue}
                    selectAgentGuide={selectAgentGuide}
                    attachments={attachments}
                    fetchMessagesStatus={fetchMessagesStatus}
                    investigativeCustomerMessage={investigativeCustomerMessage}
                    selectedCustomerMessage={selectedCustomerMessage}
                    showClipboard={showClipboard}
                    toggleEmailClipboard={toggleEmailClipboard}
                />
            </div>
            {showTicketActionModal && (
                <CloseTicket
                    show={showTicketActionModal}
                    closeModal={() => toggleTicketActionModal(false)}
                    handleSuccess={handleTicketSuccess}
                    ticketToClose={ticketToClose}
                />
            )}
        </div>
    );
};

export default ChatTickets;
